export const APP_INDICE_MENU = [
          {value: "_", label:"请选择指标"},
          {value: "adpv", label:"展现量"},
          {value: "adclick", label:"点击量"},
          {value: "adctr", label:"点击率"},
          {value: "adcost", label:"消费"},
          {value: "adcpc", label:"CPC"},
          {value: "adcpm", label:"CPM"}
]



// WEBPACK FOOTER //
// ./src/pageview/app/constants.js